import React from 'react'
import styled from 'styled-components'
import PageHeader from 'components/atoms/PageHeader'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import GuruChat from 'features/bpDetails/Components/guru/GuruChat'

/**
 * Full-page Guru. Renders the user-mode chat (global / across-all-buildings)
 * with the same engine the widget uses, just inside a dedicated route so
 * power users have a real canvas instead of the floating panel.
 *
 * Lives at /guru. The widget's "Expand to full page" button on user-mode
 * navigates here.
 */
const GuruPage = () => (
  <Wrap>
    <PageHeader
      title={
        <Title>
          <AutoAwesomeOutlinedIcon style={{ fontSize: 24 }} />
          <span>Guru</span>
          <Subtitle>Across all your Building Passports</Subtitle>
        </Title>
      }
    />
    <ChatCanvas>
      <GuruChat userMode mode="tab" />
    </ChatCanvas>
  </Wrap>
)

export default GuruPage

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 0 8px;
`

const Title = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.colors.haiti};
`

const Subtitle = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.grey?.[800] || '#94a3b8'};
  border-left: 1px solid ${({ theme }) => theme.colors.lightGrey};
  padding-left: 10px;
  margin-left: 4px;
`

const ChatCanvas = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 14px;
  overflow: hidden;
  margin: 8px 0 16px;
`
